import React from "react";
import { useSelector } from "react-redux";
import { IStoreState } from "../../../../../../redux/initialStoreState";
import { useDispatchWrapper } from "../../../../../../hooks";
import { fetchAutomobileVehicleListAsync } from "../../../../../../redux/automobileVehicle/automobileVehicleActions";

export const useAutomobilePolicyVehcileInfo = (customerPolicyId?: number) => {
  const dispatch = useDispatchWrapper();
  const {vehiclesList, vehiclesListLoading} = useSelector(
    (storeState: IStoreState) =>
      storeState.automobile.vehicle.VehicleInformation
  );

  const vehcileDropdown = React.useMemo(() => {
    return vehiclesList.map((item) => {
      return {
        label: `${item.incremental_number || "--"} (VIN: ${
          item.vin || "N/A"}, Year: ${item.year}, Make: ${item.make}, Model: ${item.model} )`,
        value: String(item.incremental_number || ""),
      };
    });
  }, [vehiclesList]);

  const refreshVehicleList = () => {
    if (customerPolicyId) {
      dispatch(fetchAutomobileVehicleListAsync(Number(customerPolicyId), "ACTIVE"));
    }
  }

  React.useEffect(() => {
    if (customerPolicyId) {
      dispatch(fetchAutomobileVehicleListAsync(Number(customerPolicyId), "ACTIVE"));
    }
 
  }, [customerPolicyId]);

 

  return { vehcileDropdown , vehiclesList,refreshVehicleList, vehiclesListLoading};
};
